import { FilterType, TopicSearchResult } from '../types';

import organizationInfo from './state/organization-info';

export function getFilteredTopics(
    filterType: string | undefined,
    originTopics: TopicSearchResult[],
    personalTopics: TopicSearchResult[],
    contributedTopics: TopicSearchResult[],
    bookmarks: TopicSearchResult[],
    accountEmail: string
) {
    let filteredTopics = [];
    originTopics.sortBy((topic) => topic.updated_at);

    switch (filterType) {
        case FilterType.MyMaps:
            filteredTopics = originTopics.filter((topic) => topic.email === accountEmail);
            break;
        case FilterType.SharedMaps:
            filteredTopics = originTopics.filter((topic) => (topic.is_owner || topic.is_writer) && (topic.email !== accountEmail));;
            break;
        case FilterType.PublishedMaps:
            filteredTopics = originTopics.filter((topic) => topic.discovery_level !== 'private' && topic.email === accountEmail);;
            break;
        case FilterType.ContributedMaps:
            filteredTopics = contributedTopics;
            break;
        case FilterType.BookmarkedMaps:
            filteredTopics = bookmarks;
            break;
        case FilterType.PersonalMaps:
            filteredTopics = personalTopics;
            break;
        case FilterType.AllMaps:
            filteredTopics = organizationInfo?.organization?._id
                ? originTopics.filter((topic) => topic.organization_id?.$oid === organizationInfo?.id?.$oid)
                : originTopics.filter((topic) => topic.is_owner || topic.is_writer);
            break;
        default:
            filteredTopics = originTopics;
            break;
    }
    return filteredTopics;
}

export interface NavItem {
    url?: string;
    label: string;
    teamsLabel: string;
    img?: string;
    filterType?: FilterType;
    isExpanded?: boolean;
    spaceAbove?: boolean;
    clickable?: boolean;
    teamOnly?: boolean;
    subItems?: NavItem[];
    teammateOnly?: boolean;
};

export const BACKPACK_SIDEBAR_NAV_ITEMS: NavItem[] = [
    {
        url: '/#home',
        label: 'Home',
        teamsLabel: 'Home',
        img: '/images/backpack/ic_home.svg',
        isExpanded: false,
        clickable: true,
        teammateOnly: true,
    },
    {
        url: `/#home?filter_type=${FilterType.AllMaps}`,
        label: 'Workspace',
        teamsLabel: 'Workspace',
        img: '/images/backpack/ic_team_backpack.png',
        filterType: FilterType.AllMaps,
        isExpanded: true,
        spaceAbove: true,
        clickable: false,
        subItems: [
        {
            url: `/#home?filter_type=${FilterType.AllMaps}`,
            label: `Workspace Maps`,
            teamsLabel: `Workspace Maps`,
            filterType: FilterType.AllMaps,
            teamOnly: true,
            teammateOnly: true,
        },
        {
            url: `/#home?filter_type=${FilterType.MyMaps}`,
            label: `Maps I've Created`,
            teamsLabel: `Maps I've Created`,
            filterType: FilterType.MyMaps,
            teammateOnly: true,
        },
        {
            url: `/#home?filter_type=${FilterType.SharedMaps}`,
            label: 'Shared with Me',
            teamsLabel: `Shared with Me`,
            filterType: FilterType.SharedMaps,
        }]
    },

    // TODO: hide for now
    // {
    //     url: `/#home?filter_type=${FilterType.ContributedMaps}`,
    //     label: `Maps I've Contributed to`,
    //     img: '/images/backpack/ic_hand.svg',
    //     filterType: FilterType.ContributedMaps,
    // },
    // {
    //     url: `/#home?filter_type=${FilterType.PublishedMaps}`,
    //     label: 'Published to Proxi',
    //     teamsLabel: `Workspace Maps Published to Proxi`,
    //     img: '/images/backpack/ic_eye.svg',
    //     filterType: FilterType.PublishedMaps,
    // },

    {
        label: 'Folders',
        teamsLabel: `Workspace Folders`,
        img: '/images/backpack/ic_folder_outlined.svg',
        isExpanded: false,
        spaceAbove: false,
        clickable: false,
        teammateOnly: true,
    },
    {
        label: 'Public Profiles',
        teamsLabel: 'Public Profiles',
        img: '/images/backpack/ic_profile.png',
        isExpanded: false,
        spaceAbove: false,
        clickable: false,
        teammateOnly: true,

    },
    {
        url: `/#home?filter_type=${FilterType.AllMaps}`,
        label: 'Personal Backpack',
        teamsLabel: 'Personal Backpack',
        img: '/images/backpack/ic_personal_backpack.png',
        filterType: FilterType.AllMaps,
        isExpanded: true,
        spaceAbove: true,
        clickable: false,
        subItems: [
        {
            url: `/#home?filter_type=${FilterType.PersonalMaps}`,
            label: 'Personal',
            teamsLabel: `My Personal Maps`,
            filterType: FilterType.PersonalMaps,
            spaceAbove: false,
        },
        {
            url: `/#home?filter_type=${FilterType.BookmarkedMaps}`,
            label: 'Bookmarked',
            teamsLabel: `My Bookmarked Maps`,
            filterType: FilterType.BookmarkedMaps,
            spaceAbove: false,
        },
        {
            url: `/#home?filter_type=${FilterType.ContributedMaps}`,
            label: `Maps I've Contributed to`,
            teamsLabel: `Maps I've Added To`,
            img: '/images/backpack/ic_hand.svg',
            filterType: FilterType.ContributedMaps,
        }]
    }
];

export const BACKPACK_SIDEBAR_NAV_ITEMS_SETTINGS: NavItem[] = [
        {
        label: 'Workspace Settings',
        teamsLabel: `Members, Settings, & Subscription`,
        img: '/images/ic_settings.svg',
        isExpanded: false,
        spaceAbove: true,
        teamOnly: true,
        teammateOnly: true,
    }
];

export function findCurrentFilterTypeInfo(filterType: string | undefined) {
    const foundInfo = BACKPACK_SIDEBAR_NAV_ITEMS.find((item) => item?.filterType === filterType);
    if (foundInfo === undefined) {
        return {
            url: `/#home?filter_type=All`,
            label: 'All Maps',
            teamsLabel: 'All Maps',
            filterType: 'All',
        };
    }
    return foundInfo;
}

